/** Mission / event / total token values from a roster-file player row. */
export function getParticipationTokenState(player) {
  const redacted = Boolean(player?.tokensRedacted);
  const mission = player?.missionToken;
  const events = player?.eventToken;
  const hasMission = typeof mission === 'number';
  const hasEvents = typeof events === 'number';
  const total =
    hasMission || hasEvents
      ? Number(mission || 0) + Number(events || 0)
      : null;

  return { redacted, mission, events, total };
}
